import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../../base.graphql";
export const citizenServicesGroupField =`
id
groupUniqueId
groupType
`;



export const GET_CITIZEN_SERVICES_GROUP = gql`
query CitizenGetServicesGroups{
    citizenGetServicesGroups{
    ${baseResponseGraphqlField}
    data {
      ${citizenServicesGroupField}
    }
  }
}
`
;